export { default as QuickBookingArticleB } from './QuickBookingArticleB'
export { default as QuickBookingArticleBSkeleton } from './Skeleton'
